<template>
  <v-container fluid>
    <v-row>
      <v-col
        cols="12"
        :sm="6"
      >
        <v-text-field
          :label="$t('name')"
          type="text"
          v-model="item.name"
        />
      </v-col>
      <v-col
        cols="12"
        :sm="6"
      >
        <v-text-field
          :label="$t('number')"
          type="text"
          v-model="item.number"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="1"
        :sm="6"
      >
        <v-text-field
          :label="$t('showSeminarsAfter')"
          type="text"
          v-model="item.__Fdate.date"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

  import TenantMixin from "@/mixins/TenantMixin";

  export default {
    name: 'SeminarPackageFilter',
    mixins: [TenantMixin],
    props: {
      values: {
        type: Object,
        required: true
      }
    },
    computed: {
      item() {
        return this.initialValues || this.values;
      },
    },
  };
</script>
